module.exports = __webpack_public_path__ + "static/media/Y8.252a67b7.mp3";